import React from 'react'
import { SGTitle } from "../../component"

const SGAboutTitle = props => {
    return (
        <SGTitle className="pb-4">{props.children}</SGTitle>
    )
}

export default SGAboutTitle